var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgSolidity = function SvgSolidity(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1232_8732)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1232_8732)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M18.0511 0.5L13.9763 8.16714H5.83301L9.90465 0.5H18.0511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.9769 8.16714H22.1233L18.0517 0.5H9.90527L13.9769 8.16714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.90465 15.831L13.9763 8.16714L9.90465 0.5L5.83301 8.16714L9.90465 15.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M9.94629 27.3332L14.021 19.666H22.1674L18.0927 27.3332H9.94629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.0204 19.666H5.87402L9.94566 27.3332H18.0921L14.0204 19.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M18.0912 12.0024L14.0195 19.6663L18.0912 27.3334L22.1659 19.6663L18.0912 12.0024Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_8732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1232_8732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3333,
    height: 26.8333,
    fill: "white",
    transform: "translate(5.83301 0.5)"
  })))));
};
export default SvgSolidity;